export function getProposalColumnClass({
  searchActive,
  isRecommender,
}: {
  searchActive: boolean;
  isRecommender: boolean;
}): string {
  if (!searchActive) {
    return "w-100 max-w-100";
  }

  return isRecommender ? "w-[22rem]" : "w-[60%]";
}
